import { Breadcrumbs, Anchor } from "@mantine/core";

function BreadcrumbsLinks({ linksArr }) {
  const items = linksArr.map((item, index) => (
    <Anchor href={item.href} key={index}>
      {item.title}
    </Anchor>
  ));
  return (
    <div className="w-full max-w-[1280px] mx-auto">
    <Breadcrumbs
      separator=">"
      separatorMargin="xs"
      mt="xs"
      className="flex flex-wrap gap-1 ml-2 md:ml-10"
    >
      {items}
    </Breadcrumbs>
    </div>
  );
}

export default BreadcrumbsLinks;
